import pannable from '../pannable/index'
import IdManager from '../IdManager/index'

import utils from '../utils/index'

import constants from '../constants/index'

import strictClick from '../strictClick/index'

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)

      this["BackgroundMixin@handleMouseDown"] = this["BackgroundMixin@handleMouseDown"].bind(this)
    }

    getObjectsByPath(path) {
      // @ts-ignore
      let selectBbox = Snap.path.getBBox(path)
        , included = {}

      Object.keys(this.shapes).forEach(shapeId => {
        let { id, type, name, matrix } = this.shapes[shapeId]
          , { path, html, bbox, name: typeName } = this.getShapeDefByType(type)

        // @ts-ignore
        if (Snap.path.isBBoxIntersect(selectBbox, Snap.path.getBBox(Snap.path.map(path, Snap.matrix(...matrix).translate(-(bbox.x + bbox.width / 2), -(bbox.y + bbox.height / 2)))))) {
          included[shapeId] = true
        }
      })
      return included
    }

    install() {
      super.install()
      let selectStartPoint = { x: 0, y: 0 }
      let onPan = (dx, dy, x, y, e, panningTarget, panOffset) => {
        if (panningTarget.id === this.id) {
          if (constants.tools.hand === (this.tool)) {
            // 平移画布
            let m = this.matrix.slice(0)
            m[4] += dx
            m[5] += dy
            this.changeMatrix(m)
          }

          if (constants.tools.marquee === (this.tool)) {
            let box = this.svg.getBoundingClientRect()
              , endPoint = utils.unapplyMatrix(this.matrix, {
                x: x - box.left,
                y: y - box.top
              })

            this.selectPath = `M ${selectStartPoint.x} ${selectStartPoint.y} H ${endPoint.x} V ${endPoint.y} H ${selectStartPoint.x}`

            this.requestAutoScroll(x, y)
          }

          // if (constants.modeFilter.lassoTool(this.mode)) {
          //   let box = this.svg.getBoundingClientRect()
          //     , endPoint = utils.unapplyMatrix(this.matrix, {
          //       x: x - box.left,
          //       y: y - box.top
          //     })
          //   this.selectPath += `L ${endPoint.x} ${endPoint.y}`
          // }

        }
      }, onPanStart = (x, y, e, panningTarget, panOffset) => {


        if ((constants.tools.marquee === (this.tool)) && panningTarget.id === this.id) {
          let box = this.svg.getBoundingClientRect()
          selectStartPoint = utils.unapplyMatrix(this.matrix, {
            x: e.clientX - box.left,
            y: e.clientY - box.top
          })
          this.selectPath = `M  ${selectStartPoint.x} ${selectStartPoint.y} `
        }

      }, onPanEnd = (e, panningTarget) => {
        if (constants.tools.hand === (this.tool)) {
          this.isPanningBackground = false
        }
        if (constants.tools.marquee === (this.tool) && panningTarget.id === this.id) {
          setTimeout(() => { // 避免和背景的点击事件竞争了
            this.selectsObjectIds = this.getObjectsByPath(this.selectPath)
            this.selectPath = null
            this.emit("selectEnd", Object.keys(this.selectsObjectIds).map(shapeId => this.shapes[shapeId]))
          }, 0)
          this.cancelAutoScroll()
        }
      }

      this["Background~pannableHandler"] = pannable(this.svg, onPan, onPanStart, onPanEnd)

      this.svg.addEventListener("mousedown", this["BackgroundMixin@handleMouseDown"], false)

      this["BackgroundMixin@handleClick"] = strictClick(this.svg, e => {
        if (utils.hasClass(e.target, "background")) {
          this.blur()
        }
      })
    }

    destroy() {
      super.destroy()
      this["Background~pannableHandler"]()
      this.svg.removeEventListener("mousedown", this["BackgroundMixin@handleMouseDown"], false)
      this["BackgroundMixin@handleClick"]()
    }

    ["BackgroundMixin@handleMouseDown"](e) {
      if (constants.tools.hand === (this.tools)) {
        this.isPanningBackground = true
      }
    }

    blur(silent) {
      if (silent ? true : this.emit("blur")) {
        this.focusObjectId = ""
      }
      this.selectsObjectIds = {}

    }

    changeMatrix(matrix) {
      this.matrix = matrix
    }

    zoomDefault() {
      this.changeMatrix(this.defaultMatrix)
    }

    zoomIn() {
      let m = this.matrix.slice(0);
      m[0] = m[3] = m[0] + .1;
      this.changeMatrix(m);
    }

    zoomOut() {
      let m = this.matrix.slice(0);
      m[0] = m[3] = m[0] - .1;
      this.changeMatrix(m);
    }

    display() {
      let id = this.id
        , matrix = this.matrix
        , children = super.display()

      return `
      <g 
        id="${id}"
        transform="matrix(${matrix.join(",")})"
        class="pannable"
        >

        <style>
          #${this.id} .button:hover {
            fill: rgb(255, 252, 176)
          }
          #${this.id} .button {
            fill: #fff;
            fill-opacity: .8
          }
        </style>
  
        <rect 
          x="-1000000" 
          y="-1000000" 
          width="2000000" 
          height="2000000" 
          fill="transparent"
          class="background"

        ></rect>
  
        <g pointer-events="none">
          <path 
            d="M -22 -1 H -1000 M 22 -1 H 6000 M -1 -22 V -1000 M -1 22 V 3000"
            fill = "none"
            stroke = "rgba(0,0,0,0.1)"
            stroke-width = "2"
            stroke-dasharray = "6,6"
            shape-randering = "crispEdges"
          >
          </path>
          <path d="M -15 -1 H 15 M -1 -15 V 15"
          fill = "none"
          stroke = "rgb(204, 204, 204)"
          stroke-width="2"
          stroke-linecap = "round"></path>
          <text 
            x="-10" 
            y="-10" 
            fill = "rgb(204, 204,204)"
            font-family = "consolas, menlo, dejavu sans mono, monospace"
            font-weight = "900"
            text-anchor = "end"
            alignment-baseline="baseline"
          >(0,0)</text>
        </g>
  
        ${children || ""}
  
      </g>
    `
    }
  }
} 


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/BackgroundMixin.js